import { useEffect, useState } from "react";

import { getNavElements } from "consts";
import { usePolicyDetail, useSelectedPolicy } from "data/ss-data-hooks";
import { useFlags } from "utils";

const HIDE_PROPERTY_CARRIERS = ["vave", "markel"];

export const useNavItems = () => {
  const { data } = useSelectedPolicy();
  const { data: detailData } = usePolicyDetail();
  const { policyPage: isPolicyPageEnabled } = useFlags();
  const hidePropertyTab =
    data?.isCommercial ||
    HIDE_PROPERTY_CARRIERS.includes(
      detailData?.userPolicyProperties.carrierGroup?.toLowerCase() ?? ""
    );

  const navElements = getNavElements(hidePropertyTab, isPolicyPageEnabled);
  const [navItems, setNavItems] = useState(navElements);

  useEffect(() => {
    setNavItems(getNavElements(hidePropertyTab, isPolicyPageEnabled));
  }, [hidePropertyTab, isPolicyPageEnabled]);

  return navItems;
};
